// import Question1 from "./components/Question1";
import Question1 from "./components/Question1.js";
import Question2 from "./components/Question2.js";
import Question3 from "./components/Question3.js";
import ResultScreen from "./containers/ResultScreen";
import HomeScreen from "./containers/HomeScreen"
import './App.css';
import { useEffect, useState } from "react";
import RotateModal from "./components/RotateModal"
import NextQuestionModal from "./components/NextQuestionModal"
import questionAnswers from "./containers/equalibriumQuestionAnswers.js";

import { withOrientationChange } from "react-device-detect";

function App(props) {
  // const get_values = () => {
  //   if(localStorage.getItem('answers') !== '' && localStorage.getItem('answers') !== null){
  //     return localStorage.getItem('answers')?.split(',')?.map(v => v === 'true' ? true : false)
  //   }else{
  //     return []
  //   }
  // }

  const [qIndex, setQIndex] = useState(0)
  const [questionNumber, setQuestionNumber] = useState(0)
  const [currentScreen, setCurrentScreen] = useState("Home");
  const [isNextQuestion, setIsNextQuestion] = useState("Home");
  const [answers, setAnswers] = useState([]);

  const { isPortrait, isLandscape, } = props;
  const [openPopup, setOpenPopup] = useState(true);

  const handleReloadClick = () => {
    console.log("answers", answers)
    console.log("qIndex", qIndex)
    // Update the qIndex state to trigger a re-render of the BubbleAndLine component
    if(qIndex < 5){
      setQIndex((prevQIndex) => prevQIndex + 1);
    }else{
      if(questionNumber < 2){
        setQuestionNumber(questionNumber + 1 )
        setQIndex(0)
      }else{
        setCurrentScreen("result");
      }
    }
  };

  const nextQuestion = () => {
    if(questionNumber < 2){
      setQuestionNumber(questionNumber + 1 )
      setQIndex(0)
    }
  };
  useEffect(() => {
    setIsNextQuestion(qIndex === 0 && currentScreen === "Quiz")
  }, [qIndex, currentScreen])

  // useEffect(() => {
  //   // localStorage.setItem('index', 0)
  //   // localStorage.setItem('answers', [])
  //   // localStorage.getItem('step')
  //   console.log("index:::", qIndex, localStorage.getItem('step'))
  //   console.log("answers:::", answers)
  // }, [])

  return (
    <div className="App">
      {currentScreen === "Home" && <HomeScreen setCurrentScreen={setCurrentScreen} />}
      { currentScreen === "Quiz" && questionNumber === 0 &&
        <Question1
          questionAnswer={questionAnswers[questionNumber][qIndex]}
          setAnswers={setAnswers}
          answers={answers}
          qIndex={qIndex}
          handleReloadClick={handleReloadClick}
          questionNumber={questionNumber}
          descriptionText={questionAnswers[questionNumber][6]}
        />
      }
      { currentScreen === "Quiz" && questionNumber === 1 &&
       <Question2
        questionAnswer={questionAnswers[questionNumber][qIndex]}
        setAnswers={setAnswers}
        answers={answers}
        qIndex={qIndex}
        handleReloadClick={handleReloadClick}
        questionNumber={questionNumber}
        descriptionText={questionAnswers[questionNumber][6]}
       />
      }
      { currentScreen === "Quiz" && questionNumber === 2 &&
       <Question3
        questionAnswer={questionAnswers[questionNumber][qIndex]}
        setAnswers={setAnswers}
        answers={answers}
        qIndex={qIndex}
        handleReloadClick={handleReloadClick}
        questionNumber={questionNumber}
        descriptionText={questionAnswers[questionNumber][6]}
       />
      }
      <NextQuestionModal isNextQuestion={isNextQuestion} questionNumber={questionNumber} setIsNextQuestion={setIsNextQuestion} />
      { currentScreen === "result" &&
        <ResultScreen  setCurrentScreen={setCurrentScreen} setQIndex={setQIndex} answers={answers} />
      }
      <RotateModal
        isOpen={isPortrait}
      />
    </div>
  );
}

export default withOrientationChange(App);
